export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
            关于吃瓜群
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl mx-auto">
            吃瓜群成立于2023年，是国内领先的吃瓜群众在线爆料平台。我们专注娱乐圈深度内容，从最新内幕到实时爆料，从明星动态到行业秘辛，在线爆料大全每日不间断更新。平台秉持"多方核实、拒绝谣言"的原则，为千万瓜友提供靠谱的吃瓜体验。在这里，吃瓜不仅是一种消遣，更是一种深度参与娱乐文化的全新方式。
          </p>
          <div className="flex flex-wrap items-center justify-center gap-8 mt-8">
            {[
              { icon: 'ri-user-star-line', label: '资深编辑团队', desc: '深耕圈内多年' },
              { icon: 'ri-verified-badge-line', label: '多方交叉验证', desc: '拒绝假瓜谣言' },
              { icon: 'ri-live-line', label: '全天候更新', desc: '不错过任何瓜' },
            ].map((item) => (
              <div key={item.label} className="flex flex-col items-center gap-2">
                <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100">
                  <i className={`${item.icon} text-xl text-primary-600`} />
                </span>
                <span className="text-sm font-medium text-foreground-800">{item.label}</span>
                <span className="text-xs text-foreground-500">{item.desc}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}